<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <TeamsTable
          ref="teamsTable"
          :account-id="$route.params.accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamsTable from '@/components/Application/Manage/Account/TeamsTable'

export default {
  components: {
    TeamsTable
  },
  data () {
    return {
      actions: []
    }
  },
  mounted () {
    this.actions = this.$refs.teamsTable.actions
  }
}
</script>

<style>

</style>
